import React from "react";
import { Box, Divider, Typography } from "@mui/material";
import Message from "../../assets/svgs/message.svg";
import WhatsApp from "../../assets/svgs/whatsapp-icon.svg";
import Call from "../../assets/svgs/call.svg";
import Time from "../../assets/svgs/time.svg";
import Address from "../../assets/svgs/address.svg";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function ContactUsInfo({ ContactUsModalToggler }) {
  const mobMatch = useMediaQuery("(max-width:600px)");

  return (
    <Box
      sx={{
        display: "flex",
        flexFlow: "column",
        rowGap: "32px",
        width: "346px",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "start", columnGap: "8px" }}>
        <img
          src={Message}
          style={{ marginTop: "2px" }}
          alt="message"
          width="18px"
          height="18px"
        />
        <Box>
          <Typography
            sx={{
              color: "text.primary",
              fontWeight: "600",
              fontSize: "16px",
              lineHeight: "24px",
            }}
            variant="subtitle1"
          >
            Send us a message
          </Typography>
          <Typography
            sx={{
              color: "#616161",
              marginTop: "-4px",
              fontSize: "16px",
              lineHeight: "24px",
            }}
            variant="body1"
          >
            Our friendly team is always happy to chat.
          </Typography>
          <Typography
            sx={{
              color: "text.primary",
              fontWeight: "600",
              fontSize: "16px",
              lineHeight: "24px",
              marginTop: "16px",
            }}
            variant="subtitle1"
          >
            info@machineryplanet.ae
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: "flex", alignItems: "start", columnGap: "8px" }}>
        <img
          style={{ marginTop: "2px" }}
          src={WhatsApp}
          alt="message"
          width="18px"
          height="18px"
        />
        <Box>
          <Typography
            sx={{
              color: "text.primary",
              fontWeight: "600",
              fontSize: "16px",
              lineHeight: "24px",
            }}
            variant="subtitle1"
          >
            Whatsapp us
          </Typography>
          <Typography
            sx={{
              color: "#616161",
              marginTop: "-4px",
              fontSize: "16px",
              lineHeight: "24px",
            }}
            variant="body1"
          >
            For your convenience.
          </Typography>
          <Typography
            sx={{
              color: "text.primary",
              fontWeight: "600",
              fontSize: "16px",
              lineHeight: "24px",
              marginTop: "16px",
            }}
            variant="subtitle1"
          >
            +971 54 701 7869
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: "flex", alignItems: "start", columnGap: "8px" }}>
        <img
          style={{ marginTop: "2px" }}
          src={Call}
          alt="message"
          width="18px"
          height="18px"
        />
        <Box>
          <Typography
            sx={{
              color: "text.primary",
              fontWeight: "600",
              fontSize: "16px",
              lineHeight: "24px",
            }}
            variant="subtitle1"
          >
            Call us{" "}
          </Typography>
          <Typography
            sx={{
              color: "#616161",
              marginTop: "-4px",
              fontSize: "16px",
              lineHeight: "24px",
            }}
            variant="body1"
          >
            Please don’t mind if we miss your call due to higher call volumes.{" "}
          </Typography>
          <Typography
            sx={{
              color: "text.primary",
              fontWeight: "600",
              fontSize: "16px",
              lineHeight: "24px",
              marginTop: "16px",
            }}
            variant="subtitle1"
          >
            +971 54 701 7869{" "}
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: "flex", alignItems: "start", columnGap: "8px" }}>
        <img
          style={{ marginTop: "2px" }}
          src={Address}
          alt="message"
          width="18px"
          height="18px"
        />
        <Box>
          <Typography
            sx={{
              color: "text.primary",
              fontWeight: "600",
              fontSize: "16px",
              lineHeight: "24px",
            }}
            variant="subtitle1"
          >
            Visit us{" "}
          </Typography>
          <Typography
            sx={{
              color: "#616161",
              marginTop: "-4px",
              fontSize: "16px",
              lineHeight: "24px",
            }}
            variant="body1"
          >
            JLT, Cluster R, Unit R6. Dubai, UAE{" "}
          </Typography>
          <Typography
            sx={{
              color: { xs: "primary.main", sm: "text.primary" },
              fontWeight: "600",
              fontSize: "16px",
              lineHeight: "24px",
              marginTop: "16px",
            }}
            variant="subtitle1"
            onClick={() => {
              mobMatch && ContactUsModalToggler(true, "appointment");
            }}
          >
            Contact us to take an appointment{" "}
          </Typography>
        </Box>
      </Box>
      <Divider sx={{ color: "#D6D6D6" }} />

      <Box sx={{ display: "flex", alignItems: "start", columnGap: "8px" }}>
        <img
          style={{ marginTop: "2px" }}
          src={Time}
          alt="message"
          width="18px"
          height="18px"
        />
        <Box>
          <Typography
            sx={{
              color: "text.primary",
              fontWeight: "600",
              fontSize: "16px",
              lineHeight: "24px",
            }}
            variant="subtitle1"
          >
            Business Hours{" "}
          </Typography>
          <Typography
            sx={{
              color: "#616161",
              marginTop: "-4px",
              fontSize: "16px",
              lineHeight: "24px",
            }}
            variant="body1"
          >
            Saturday-Thursday: 10AM to 5PM
            <br />
            Friday: Closed
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
